module.exports = __webpack_public_path__ + "static/pic07-e026e5255d9c32f519ca936d0a160dea.jpg";